import { KycVerificationStatusEnumType } from "@oysterhr/schema"

export enum Action {
  verify = "verify",
  profile = "profile",
}

const reverifyText = {
  action: Action.verify,
  text: "reverifyIdentity",
  shouldCreateNewVerification: true,
}

export const VerificationTextByStatus = {
  [KycVerificationStatusEnumType.Abandoned]: reverifyText,
  [KycVerificationStatusEnumType.Approved]: null,
  [KycVerificationStatusEnumType.Declined]: {
    action: Action.profile,
    text: "identityRejected",
    shouldCreateNewVerification: false,
  },
  [KycVerificationStatusEnumType.Expired]: reverifyText,
  [KycVerificationStatusEnumType.ResubmissionRequired]: reverifyText,
  [KycVerificationStatusEnumType.Started]: {
    action: Action.verify,
    text: "continueVerification",
    shouldCreateNewVerification: false,
  },
  [KycVerificationStatusEnumType.Submitted]: {
    action: Action.profile,
    text: "verifyingProfile",
    shouldCreateNewVerification: false,
  },
  [KycVerificationStatusEnumType.NotStarted]: {
    action: Action.verify,
    text: "verifyIdentity",
    shouldCreateNewVerification: false,
  },
}
